<template>
  <div class="selectSupplier">
    <el-input prefix-icon="el-icon-s-order" placeholder="请点击选择文章" readonly :value="displayValue" @click.native="showDialog">
      <el-button slot="append" @click="showDialog">选择</el-button>
    </el-input>
    <!-- 弹窗选择内容 -->
    <el-dialog title="请点击选择文章" :visible.sync="open" width="80%" append-to-body>
      <el-form :inline="true">
        <el-form-item label="文章名称">
          <el-input v-model="listQuery.title" placeholder="请输入文章名称" clearable @change="SearchData" @keyup.enter.native="SearchData"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SearchData">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表 -->
      <el-table v-loading="loading" :data="list" @row-click="select">
        <el-table-column align="center" prop="title" label="文章名称"></el-table-column>
        <el-table-column align="center" prop="source" label="文章来源"></el-table-column>
        <el-table-column align="center" label="操作">
          <el-button size="mini" type="primary">点击选择</el-button>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="clear">清空</el-button>
        <el-button @click="cancel">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/article' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
export default {
  name: 'SelectArticle',
  components: { Pagination },
  mixins: [commonList],
  props: {
    value: {
      default: null,
      type: [String, Number]
    },
    status: {
      // 父组件传来的查询条件  是否查询已经启用的供应商
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // api接口方法
      api,
      open: false,
      loading: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      selectItem: null// 选择的对象
    }
  },
  computed: {
    displayValue() {
      if (this.selectItem != null) {
        return this.selectItem ? this.selectItem.title : ''
      }
      return ''
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.loadInfo()
      },
      // 第一次赋值就执行
      immediate: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    showDialog() {
      this.open = true
    },
    cancel() {
      this.open = false
    },
    clear() {
      this.selectItem = null
      this.open = false
      this.listQuery.name = null
      this.listQuery.phone = null
      this.$emit('input', null)
      this.SearchData()
    },
    /**
       * 选择子项目
       */
    select(item) {
      this.selectItem = item
      this.open = false
      if (item.id !== this.value) {
        this.$emit('change', item.id)
      }
      this.$emit('input', item.id)
    },
    SearchData() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      this.loadData()
      this.loading = false
    },
    /**
       * 查询单条数据（显示名称）
       */
    loadInfo() {
      if (this.value) {
        api.Detail(this.value).then(res => {
          this.selectItem = res.data
        })
      } else {
        this.selectItem = ''
      }
    }
  }
}
</script>
  <style scoped>
  .selectSupplier {
    display: inline-block;
  }
  </style>
